import create from '@verndale/core';

let modulesCreated = false;

/* eslint-disable global-require */
function reactComponent(Component, nodeList) {
  const React = require('react');
  const { createRoot } = require('react-dom/client');

  nodeList.forEach((node) =>
    createRoot(node).render(<Component {...node.dataset} />)
  );
}

document.addEventListener('DOMContentLoaded', () => {
  if (modulesCreated) return;
  modulesCreated = true;

  create([
    {
      name: 'fane',
      loader: () => import('./react-components/fane'),
      render: reactComponent
    },
  ]);
});
